import React from 'react'
import Topbar from '../Mainhomeone/Topbar'
import Header from '../../Globle/Header1'
import Navigation from '../Mainhomeone/Navigation'
import Banner from '../../Home/Mainhomeone/Banner'
import Services from '../Mainhomeone/Services'
import HomeProduct from '../Mainhomeone/HomeProduct'
import DealProdect from '../Mainhomeone/DealProduct'
import Prodect from '../Mainhomeone/AdvertiseProduct'
import Shop from '../Mainhomeone/ShopCategory'
import ProdectHome from '../Mainhomeone/HomeProductOne'
import AdvertiseOne from '../Mainhomeone/AdvertiseOne'
import HomeProductTwo from '../Mainhomeone/HomeProductTwo'
import Footer from '../../Globle/Footer1'


const Main = () => {
    return (
        <>
            <Topbar />
            <Header />
            <Navigation />
            <Banner />
            <Services />
            <HomeProduct />
            <DealProdect />
            <Prodect />
            <Shop />
            <ProdectHome />
            <AdvertiseOne />
            <HomeProductTwo />
            <Footer />

        </>
    )
}

export default Main
